import React from 'react'
import logo from './../Images/vistaplots-logo.png';
import { FaFacebookF, FaReddit, FaTwitter } from "react-icons/fa";
import { Link } from 'react-router-dom';
const Footer = () => {
  return (
    <>
<footer>
    <div className="container-fluid">
        <div className="border-top"></div>
    </div>
    <div className="container py-60">
        <div className="row">
            <div className="col-lg-2 order-1 order-lg-1">
                <div className="footer-logo text-lg-start text-center mb-4">
                    <img src={logo} alt=""/>
                </div>
            </div>
            <div className="col-lg-6 order-3 order-lg-2">
                <div className="row">
                    <div className="col-md-4 col-6">
                        <div className="footer-head">
                            <h3>Resources</h3>
                        </div>
                        <div className="footer-links">
                            <ul>
                                <li><a href="/blog">Blog</a></li>
                                <li><a href="/api">API</a></li>
                                <li><a href="/apps-and-extras">Apps &amp; Extras</a></li>
                                <li><a href="/case-study">Case Study</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-4 col-6">
                        <div className="footer-head">
                            <h3>Company</h3>
                        </div>
                        <div className="footer-links">
                            <ul>

                                <li><a href="/about">About Us</a></li>
                                <li><a href="/customers">Customers</a></li>
                                <li><a href="/community">Community</a></li>
                                <li><a href="/request-a-feature">Request a Feature</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-4 col-6">
                        <div className="footer-head">
                            <h3>Support</h3>
                        </div>
                        <div className="footer-links">
                            <ul>
      
                                <li><a href="/help-center">Help Center</a></li>
                                <li><a href="/webinars">Webinars</a></li>
                                <li><a href="/tutorials">Tutorials</a></li>
                                <li><a href="/tweet-us">Tweet @ Us</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-lg-4 order-2 order-lg-3">
                <div className="subscribe-bx  mb-4 mb-lg-0">
                    <div className="footer-head text-lg-start text-center">
                        <h3>Signup and recevie latest tips via email.
</h3>
                    </div>
                    <div className="footer-input">
                        <form action="">
                            <input placeholder='Your Email Here' type="text"/>
                            <button>Subscribe</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div className="container-fluid">
        <div className="border-top"></div>
    </div>
    <div className="container foot-bottom">
        <div className="d-flex flex-lg-row flex-column align-items-center justify-content-lg-between">
            <div className="copyright text-lg-start text-center mb-lg-0 mb-4">
                <p>Copyright Visom6 Technology Pvt Ltd © 2022 <a href="">workXid</a> | <a href="">Privacy</a> | <a href="">Terms</a> | <a
                        href="">Security</a> | <Link to="/admin-dashboard">Dashboard</Link></p>
            </div>
            <div className="footer-social">
                <span><a href=""><FaFacebookF/></a></span>
                <span><a href=""><FaReddit/></a></span>
                <span><a href=""><FaTwitter/></a></span>
            </div>
        </div>
    </div>
</footer>
    </>
  )
}

export default Footer